module.exports = __webpack_public_path__ + "static/media/beaconQueueHeader.9ef81e49.jpg";